import { createRestApi } from '~/App/Api/rest';

export default async function deleteGreetAction(greetId: string) {
  const api = createRestApi('/api/v2/greets');

  return await api.delete(greetId);
}
